import React, { useEffect, useState, useRef } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { PhoneIcon } from "@heroicons/react/24/outline";
import { useOutsideClick } from "@/hooks/use-outside-click";
import BeratungsterminModal from "@/components/form/BeratungsterminModal";

export default function SuccessModal({ modal, title }) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const containerRef = useRef(null);

    useEffect(() => {
setShowModal(modal)
    },[modal])


  return (
    <>
      <AnimatePresence>
        {showModal && (
          <motion.div
            className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              onClick={(e) => e.stopPropagation()}
              className="bg-white h-fit  w-[80vh] max-auto  p-6 rounded-sm shadow-md max-w-sm mx-auto"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              transition={{ type: "spring", stiffness: 500, damping: 30 }}
              ref={containerRef}
            >
              <h2 className="text-xl text-prime-950 font-semibold mb-4">
                {title ? title : "Bewertung erfolgreich angefragt!"} 
              </h2>
              <p>Wir würden uns in kürze bei Ihnen melden</p>
              <p className="font-medium">
                Wenn Sie weitere Fragen haben, rufen Sie uns gerne an unter{" "}
                <span>
                  <a className="text-[#e95c0c]" href="">
                    <PhoneIcon className="inline w-5 h-5" /> 02403 883170
                  </a>
                </span>
              </p>
              <div className="flex pt-10 justify-end space-x-4">
               
                
                <button
                  onClick={()=>navigate('/')}
                  className="px-4 py-2 bg-prime-700 hover:bg-prime-400 text-white rounded-md"
                >
                  Zur Startseite
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
